import { render, staticRenderFns } from "./InviteAndEarnBanner.vue?vue&type=template&id=480a4cb4"
import script from "./InviteAndEarnBanner.vue?vue&type=script&lang=js"
export * from "./InviteAndEarnBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports